// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { yooldoVerse as _yooldoVerse } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the yooldoVerse chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 50005
 * Chain Name: Yooldo Verse
 * Default Block Explorer: https://explorer.yooldo-verse.xyz
 * Default RPC URL: https://rpc.yooldo-verse.xyz
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { yooldoVerse } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: yooldoVerse,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const yooldoVerse = createCommon({
	..._yooldoVerse,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
